import fetchAPI from "./fetchAPI"

export async function fetchFormData(form, token) {
  const data = await fetchAPI(
    `query($form: String!, $token: String!) {
      fetchFormData(form: $form, token: $token) {
        success,
        data,
      }
    }`,
    {
      variables: { form, token }
    },
    true
  )

  return data
}
